import { createSelector, createStructuredSelector } from 'reselect';
import { AVC_NAMESPACE } from 'Container/App/constants';
import { initialState } from './reducer';
import { RootState } from 'Container/App/types';
import {
    selectActiveOverlay,
    selectAddress,
    selectAvcResult,
    selectGigakombi,
    selectIsOverlayOpen,
    selectPreMarketingType,
    selectTariff,
} from 'Container/App/selector';

const selectState = (state: RootState) => state[AVC_NAMESPACE] || initialState;

export const selectAvcState = createSelector(selectState, state => state);
export const selectLoading = createSelector(selectState, state => state.loading);
export const selectAddresses = createSelector(selectState, state => state.addresses);
export const selectForm = createSelector(selectState, state => state.form);
export const selectError = createSelector(selectState, state => state.error);
export const selectAccessSupplier = createSelector(selectState, state => state.accessSupplier);
export const selectRolloutEndMonth = createSelector(selectState, state => state.rolloutEndMonth);
export const selectRolloutStatus = createSelector(selectState, state => state.rolloutStatus);
export const selectAvailabilityIndicator = createSelector(selectState, state => state.availabilityIndicator);

export const selectors = createStructuredSelector({
    loading: selectLoading,
    form: selectForm,
    address: selectAddress,
    addresses: selectAddresses,
    error: selectError,
    avcResult: selectAvcResult,
    selectedTariff: selectTariff,
    gigakombi: selectGigakombi,
    accessSupplier: selectAccessSupplier,
    rolloutEndMonth: selectRolloutEndMonth,
    rolloutStatus: selectRolloutStatus,
    availabilityIndicator: selectAvailabilityIndicator,
    activeOverlay: selectActiveOverlay,
    isOverlayOpen: selectIsOverlayOpen,
    preMarketingType: selectPreMarketingType,
});
